import { css } from 'styled-components';

export const MediaQuery = {
  sm: '@media (max-width: 768px)',
  md: '@media (max-width: 1024px)',
};

export const globalStyles = css`
  :root {
    --white: #ffffff;
    --dimWhite: '#faf9fe';

    --black: #28293d;

    --gray: #8f90a6;
    --gray-text: #9d9eb1;

    --green-100: #00d930;
    --green-200: #10d4d4;
    --green-300: #67aa9e;

    --blue-100: #0041d9;
    --blue-200: #04eefd;
    --blue-300: #61c7ff;
    --blue-400: #0d7cba;

    --purple-100: #5d5bcc;

    --pink-100: #e85bc1;
    --pink-200: #cd5be8;
    --pink-300: #9a64a3;

    --yellow-100: #e5e85b;
    --yellow-200: #a1a40a;

    --orange-100: #d98200;
    --orange-200: #e89f5b;
    --orange-300: #ffd486;

    --red-100: #f4455a;

    --cores-sebrae-primaria-main: #0041d9;
    --cores-sebrae-secundaria-darker: #39a4df;
    --texto-background-texto-texto-2: #555770;
    --texto-background-texto-texto-3: #8f90a6;
  }

  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', sans-serif;
    background: var(--dimWhite);
    height: 100%;
  }
`;
